import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { numberFormat } from 'utils/app.utils';

async function ExportToExcel({ title, data, branchName, dateStart, dateEnd, status, t,
}: { title: string, data: any[]; branchName: string; dateStart: string; dateEnd: string; status: string; t: any }) {
    const workbook = new ExcelJS.Workbook()
    const sheet = workbook.addWorksheet(title)

    // Title
    const titleRow = sheet.addRow([title])
    titleRow.font = { bold: true, size: 16 }
    sheet.mergeCells(titleRow.number, 1, titleRow.number, 9)
    titleRow.alignment = { horizontal: 'left' }

    // Filters
    const filterRow = sheet.addRow([
        `${t('REPORT.TABLE.DECREASE.BRANCH')}: ${branchName || '-'}  ${t('REPORT.TABLE.DECREASE.DATE_START')}: ${dateStart || '-'}  ${t('REPORT.TABLE.DECREASE.DATE_END')}: ${dateEnd || '-'}  ${t('REPORT.FILTER.APPOINTMENT_STATUS')}: ${status || '-'}`
    ])
    filterRow.font = { size: 11 }
    sheet.mergeCells(filterRow.number, 1, filterRow.number, 9)
    const headCells = [
        { label: t('TABLE.NO'), width: 8 },
        { label: t('VN'), width: 18 },
        { label: t('วันที่รับบริการ'), width: 20 },
        { label: t('รหัสผู้ป่วย'), width: 16 },
        { label: t('ชื่อผู้ป่วย'), width: 20 },
        { label: t('การรักษา/บริการ'), width: 50 },
        { label: t('ยอดค่าใช้จ่าย'), width: 16 },
        { label: t('สถานะเบิกจ่าย'), width: 16 },
        { label: t('ผู้บันทึก/เจ้าหน้าที่'), width: 30 }
    ]
    sheet.columns = headCells.map(c => ({ width: c.width }))
    const headerRow = sheet.addRow(headCells.map(c => c.label))
    headerRow.font = { bold: true, size: 12 }

    headerRow.eachCell((cell, colNumber) => {

        if ([1, 8, 9].includes(colNumber)) {
            cell.alignment = { horizontal: 'center', vertical: 'middle' }
        } else if (colNumber === 7) {
            cell.alignment = { horizontal: 'right', vertical: 'middle' }
        } else {
            cell.alignment = { horizontal: 'left', vertical: 'middle' }
        }
    })
    if (!data || data.length === 0) {
        const noDataRow = sheet.addRow([t('REPORT.TITLE.NO_DATA')])
        sheet.mergeCells(noDataRow.number, 1, noDataRow.number, headCells.length)
        noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
        noDataRow.alignment = { horizontal: 'center' }
    } else {
        data.forEach((row: any, idx: number) => {
            const formatTreatments = (treatments: any[]) => {
                if (!treatments || treatments.length === 0) {
                    return '';
                }

                const groupedByDoctor = treatments.reduce((acc, treatment) => {
                    const doctorName = treatment.userFullname || 'Unknown Doctor';
                    if (!acc[doctorName]) {
                        acc[doctorName] = [];
                    }
                    acc[doctorName].push(treatment);
                    return acc;
                }, {});

                let result = '';
                for (const doctorName in groupedByDoctor) {
                    result += `Dr. ${doctorName}\n`;
                    groupedByDoctor[doctorName].forEach((treatment: any) => {
                        result += `Tx. ${treatment.operativeName}\n`;
                        if (treatment.note) {
                            result += `Note. ${treatment.note}\n`;
                        }
                    });
                }
                return result.trim();
            };

            const newRow = sheet.addRow([
                idx + 1,
                row.vnNumber || '-',
                row.date ? moment(row?.date).add(543, 'year').format('DD/MM/YYYY') : '-',
                row.cnNumber || '-',
                row.patientFullname || '-',
                formatTreatments(row.treatments) || '-',
                numberFormat(row.price, 2),
                row?.statusClaim === '0' ? 'รอเบิกจ่าย' : 'เบิกจ่ายสำเร็จ',
                `${row.updatedBy}\n ${row.updatedAt ? moment(row.updatedAt).add(543, 'year').format('DD/MM/YYYY HH:mm') : '-'} น.`,
            ])

            newRow.eachCell((cell, colNumber) => {
                if ([1, 8, 9].includes(colNumber)) {
                    cell.alignment = { horizontal: 'center' }
                } else if (colNumber === 7) {
                    cell.alignment = { horizontal: 'right' }
                } else {
                    cell.alignment = { horizontal: 'left' }
                }
            })
        })


        // const sumRow = sheet.addRow([
        //     t('REPORT.TITLE.SUM'), '', '',
        //     numberFormat(_.sumBy(data, 'costPerUnit') || 0, 2),
        //     numberFormat(_.sumBy(data, 'listPricePerUnit') || 0, 2),
        //     _.sumBy(data, (item: any) => Number(item.qty)) || 0,
        //     numberFormat(_.sumBy(data, 'totalCost') || 0, 2),
        //     numberFormat(_.sumBy(data, 'totalPaid') || 0, 2),
        //     numberFormat(_.sumBy(data, 'totalListPrice') || 0, 2),
        //     numberFormat(_.sumBy(data, 'grossProfit') || 0, 2),
        //     numberFormat(_.sumBy(data, 'netProfit') || 0, 2),
        // ])
        // sumRow.font = { bold: true }
        // sumRow.alignment = { horizontal: 'right' }
        // sheet.mergeCells(sumRow.number, 1, sumRow.number, 3)
    }

    // Save file
    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    saveAs(blob, `${title}_${moment().format('YYYYMMDD')}.xlsx`)
}

export default ExportToExcel 